import { RaffleTierConfig, RaffleTicket, WinnerSettlementRecord } from '../types';

export const INITIAL_RAFFLE_TIERS: RaffleTierConfig[] = [
  {
    id: 'mega',
    name: 'Mega Royal Grand Raffle',
    tagline: 'Ultimate Star Prizes • Luxury SUV Car, 10kVA Solar & ₦1M Cash Grants',
    badgeEmoji: '👑',
    ticketPrice: 10000,
    ticketPriceUsd: 10,
    drawDate: '2026-12-30T18:00:00Z',
    drawVenue: 'Ogieneni Royal Palace Main Arena (Live Streamed)',
    totalWinningSlotsCount: 8,
    maxTicketsLimit: 10000,
    status: 'open',
    bonusOfferNote: '🔥 SPECIAL OFFER: Buy 1 Mega Ticket & Get 2 Mini Tickets FREE!',
    bonusMiniTicketsPerTicket: 2,
    colorTheme: {
      bgGradient: 'from-amber-950 via-amber-900 to-yellow-950',
      border: 'border-amber-400',
      accentBg: 'bg-amber-500',
      textAccent: 'text-amber-300',
    },
    prizes: [
      {
        id: 'mega-prize-1',
        rank: 1,
        title: 'Brand New 2026 Compact SUV (Grand Royal Star Prize)',
        prizeType: 'item',
        description: 'Fully equipped 2026 luxury compact SUV with leather interior, zero mileage, and full registration.',
        estimatedValueLabel: '₦28,500,000',
        sponsorName: 'Uzairue Royal Committee & Diaspora Donors',
        icon: '🚘',
        totalWinningSlots: 1,
        drawnSlotsCount: 0,
        winnerTicketNumbers: [],
      },
      {
        id: 'mega-prize-2',
        rank: 2,
        title: '10kVA Solar Hybrid Generator System',
        prizeType: 'item',
        description: 'Complete 10kVA solar hybrid system with 8 panels, inverter & lithium-ion battery array + installation.',
        estimatedValueLabel: '₦6,800,000',
        sponsorName: 'Etsako Green Energy Ltd & Uzairue Guild',
        icon: '☀️',
        totalWinningSlots: 2,
        drawnSlotsCount: 0,
        winnerTicketNumbers: [],
      },
      {
        id: 'mega-prize-3',
        rank: 3,
        title: '₦1,000,000 Royal Executive Cash Grant',
        prizeType: 'cash',
        cashAmountValue: 1000000,
        description: 'Direct bank transfer of ₦1,000,000 cash grant for business expansion or family development.',
        estimatedValueLabel: '₦1,000,000 Cash',
        sponsorName: 'HRH Ogieneni Business Guild',
        icon: '💰',
        totalWinningSlots: 2,
        drawnSlotsCount: 0,
        winnerTicketNumbers: [],
      },
      {
        id: 'mega-prize-4',
        rank: 4,
        title: 'Luxury Home Appliances Suite (65" Smart TV + Side-by-Side Fridge)',
        prizeType: 'consolation',
        description: 'Complete luxury home electronics package delivered anywhere in Nigeria.',
        estimatedValueLabel: '₦500,000',
        sponsorName: 'Friends of Uzairue Kingdom',
        icon: '📺',
        totalWinningSlots: 3,
        drawnSlotsCount: 0,
        winnerTicketNumbers: [],
      },
    ],
  },
  {
    id: 'midi',
    name: 'Midi Heritage Raffle',
    tagline: 'Scholarship & Tech Suite • Full University Tuition & Laptops',
    badgeEmoji: '🎓',
    ticketPrice: 5000,
    ticketPriceUsd: 5,
    drawDate: '2026-12-30T16:30:00Z',
    drawVenue: 'Uzairue Civic & Cultural Arcade',
    totalWinningSlotsCount: 12,
    maxTicketsLimit: 20000,
    status: 'open',
    bonusOfferNote: '💡 BONUS: Buy 3 Midi Tickets & Get 1 Mini Ticket FREE!',
    bonusMiniTicketsPerTicket: 0.33,
    colorTheme: {
      bgGradient: 'from-emerald-950 via-teal-900 to-slate-900',
      border: 'border-emerald-400',
      accentBg: 'bg-emerald-500',
      textAccent: 'text-emerald-300',
    },
    prizes: [
      {
        id: 'midi-prize-1',
        rank: 1,
        title: 'Full 1-Year University / Tertiary Scholarship Grant',
        prizeType: 'item',
        description: 'Covers full tuition, campus housing stipend, and books for one academic session at any Nigerian university.',
        estimatedValueLabel: '₦2,500,000',
        sponsorName: 'HRH Ogieneni Educational Endowment Fund',
        icon: '🎓',
        totalWinningSlots: 4,
        drawnSlotsCount: 0,
        winnerTicketNumbers: [],
      },
      {
        id: 'midi-prize-2',
        rank: 2,
        title: 'Professional High-Performance Laptop & Tech Suite',
        prizeType: 'item',
        description: 'Core i7 16GB RAM Laptop + Wireless Printer + 1-Year High-Speed Internet subscription.',
        estimatedValueLabel: '₦850,000',
        sponsorName: 'Uzairue Tech Advancement Initiative',
        icon: '💻',
        totalWinningSlots: 4,
        drawnSlotsCount: 0,
        winnerTicketNumbers: [],
      },
      {
        id: 'midi-prize-3',
        rank: 3,
        title: '₦500,000 Heritage Enterprise Cash Grant',
        prizeType: 'cash',
        cashAmountValue: 500000,
        description: 'Direct cash award to support trade, agriculture, or academic research.',
        estimatedValueLabel: '₦500,000 Cash',
        sponsorName: 'Uzairue Chamber of Commerce',
        icon: '💵',
        totalWinningSlots: 4,
        drawnSlotsCount: 0,
        winnerTicketNumbers: [],
      },
    ],
  },
  {
    id: 'mini',
    name: 'Mini Crown Raffle',
    tagline: 'Community Crown Prizes • Smartphones, Solar Home Kits & Cash',
    badgeEmoji: '📱',
    ticketPrice: 2000,
    ticketPriceUsd: 2,
    drawDate: '2026-12-30T15:00:00Z',
    drawVenue: 'Uzairue Youth Center Stadium',
    totalWinningSlotsCount: 20,
    maxTicketsLimit: 30000,
    status: 'open',
    bonusOfferNote: '🎁 PROMO: Buy 5 Mini Tickets & Get 1 Extra Mini FREE!',
    bonusMiniTicketsPerTicket: 0.2,
    colorTheme: {
      bgGradient: 'from-blue-950 via-indigo-900 to-slate-900',
      border: 'border-cyan-400',
      accentBg: 'bg-cyan-500',
      textAccent: 'text-cyan-300',
    },
    prizes: [
      {
        id: 'mini-prize-1',
        rank: 1,
        title: '5G Smartphone & 1-Year Unlimited Data Bundle',
        prizeType: 'item',
        description: 'Brand new 5G smartphone with 128GB storage + 12-month data connectivity bundle.',
        estimatedValueLabel: '₦450,000',
        sponsorName: 'Etsako Telecom Partners',
        icon: '📱',
        totalWinningSlots: 5,
        drawnSlotsCount: 0,
        winnerTicketNumbers: [],
      },
      {
        id: 'mini-prize-2',
        rank: 2,
        title: 'Portable Solar Home Lighting System',
        prizeType: 'item',
        description: 'Compact 300W solar generator box with 4 LED bulbs, phone charging ports & radio.',
        estimatedValueLabel: '₦200,000',
        sponsorName: 'Uzairue Youth Energy Guild',
        icon: '🔋',
        totalWinningSlots: 5,
        drawnSlotsCount: 0,
        winnerTicketNumbers: [],
      },
      {
        id: 'mini-prize-3',
        rank: 3,
        title: '₦100,000 Mini Crown Cash Award',
        prizeType: 'cash',
        cashAmountValue: 100000,
        description: 'Direct instant cash payout to lucky ticket holders.',
        estimatedValueLabel: '₦100,000 Cash',
        sponsorName: 'Uzairue Market Women Association',
        icon: '💸',
        totalWinningSlots: 10,
        drawnSlotsCount: 0,
        winnerTicketNumbers: [],
      },
    ],
  },
  {
    id: 'starter',
    name: 'Starter Citizen Raffle',
    tagline: 'Every Citizen Raffle • Cash Grants, Festival Souvenirs & Hampers',
    badgeEmoji: '🎟️',
    ticketPrice: 500,
    ticketPriceUsd: 0.50,
    drawDate: '2026-12-30T13:30:00Z',
    drawVenue: 'Jattu Royal Market Plaza',
    totalWinningSlotsCount: 40,
    maxTicketsLimit: 50000,
    status: 'open',
    bonusOfferNote: '🎉 POPULAR: Buy 10 Starter Tickets & Get 2 Starter Tickets FREE!',
    colorTheme: {
      bgGradient: 'from-slate-900 via-stone-900 to-amber-950',
      border: 'border-slate-500',
      accentBg: 'bg-amber-600',
      textAccent: 'text-amber-200',
    },
    prizes: [
      {
        id: 'starter-prize-1',
        rank: 1,
        title: '₦50,000 Citizen Empowerment Cash Grant',
        prizeType: 'cash',
        cashAmountValue: 50000,
        description: 'Direct instant cash transfer to boost micro-businesses or household needs.',
        estimatedValueLabel: '₦50,000 Cash',
        sponsorName: 'Uzairue Community Welfare Fund',
        icon: '💵',
        totalWinningSlots: 10,
        drawnSlotsCount: 0,
        winnerTicketNumbers: [],
      },
      {
        id: 'starter-prize-2',
        rank: 2,
        title: 'Royal Festival Commemorative Souvenir & Hamper',
        prizeType: 'consolation',
        description: 'Official Erue 2026 royal commemorative cloth, branded bag, food items & wine.',
        estimatedValueLabel: '₦30,000',
        sponsorName: 'Uzairue Central Planning Committee',
        icon: '🧺',
        totalWinningSlots: 15,
        drawnSlotsCount: 0,
        winnerTicketNumbers: [],
      },
      {
        id: 'starter-prize-3',
        rank: 3,
        title: '₦20,000 Airtime, Mobile Data & Food Voucher',
        prizeType: 'consolation',
        description: 'Instant recharge pin code or food store shopping voucher.',
        estimatedValueLabel: '₦20,000',
        sponsorName: 'Jattu Youth Volunteers',
        icon: '📲',
        totalWinningSlots: 15,
        drawnSlotsCount: 0,
        winnerTicketNumbers: [],
      },
    ],
  },
];

export const INITIAL_4TIER_TICKETS: RaffleTicket[] = [
  {
    id: 'tick_mega_1001',
    ticketNumber: 'MEGA-2026-8812',
    tierId: 'mega',
    tierName: 'Mega Royal Grand Raffle',
    buyerName: 'High Chief Raymond Braimoh',
    buyerPhone: '+234 803 112 4492',
    buyerEmail: 'raymond.b@uzairue.org',
    buyerClanOrCity: 'Jattu-Uzairue',
    quantity: 1,
    bonusTicketsCount: 2,
    bonusTicketNumbers: ['MINI-BONUS-9901', 'MINI-BONUS-9902'],
    unitPrice: 10000,
    totalAmount: 10000,
    purchasedAt: '2026-08-01T10:14:00Z',
    status: 'active',
    verificationHash: 'SHA256-MEGA-8812-990A1B2C',
    secretVerificationPin: '7721',
  },
  {
    id: 'tick_mega_1002',
    ticketNumber: 'MEGA-2026-8815',
    tierId: 'mega',
    tierName: 'Mega Royal Grand Raffle',
    buyerName: 'Dr. (Mrs) Blessing Oshiomhole',
    buyerPhone: '+234 802 334 9910',
    buyerEmail: 'blessing.o@gmail.com',
    buyerClanOrCity: 'Afashio-Uzairue',
    quantity: 2,
    bonusTicketsCount: 4,
    bonusTicketNumbers: ['MINI-BONUS-9903', 'MINI-BONUS-9904', 'MINI-BONUS-9905', 'MINI-BONUS-9906'],
    unitPrice: 10000,
    totalAmount: 20000,
    purchasedAt: '2026-08-03T14:22:00Z',
    status: 'active',
    verificationHash: 'SHA256-MEGA-8815-A1B2C3D4',
    secretVerificationPin: '4198',
  },
  {
    id: 'tick_midi_1001',
    ticketNumber: 'MIDI-2026-4401',
    tierId: 'midi',
    tierName: 'Midi Heritage Raffle',
    buyerName: 'Engr. Victor Momoh (UK Chapter)',
    buyerPhone: '+44 7700 900123',
    buyerEmail: 'victor.momoh@diaspora.org',
    buyerClanOrCity: 'Iyora (London Chapter)',
    quantity: 3,
    bonusTicketsCount: 1,
    bonusTicketNumbers: ['MINI-BONUS-9907'],
    unitPrice: 5000,
    totalAmount: 15000,
    purchasedAt: '2026-08-05T09:00:00Z',
    status: 'active',
    verificationHash: 'SHA256-MIDI-4401-F3E2D1C0',
    secretVerificationPin: '9034',
  },
  {
    id: 'tick_mini_1001',
    ticketNumber: 'MINI-2026-2201',
    tierId: 'mini',
    tierName: 'Mini Crown Raffle',
    buyerName: 'Hajia Fatima Abuda',
    buyerPhone: '+234 814 551 2289',
    buyerEmail: 'fatima.abuda@yahoo.com',
    buyerClanOrCity: 'Ikabigbo-Uzairue',
    quantity: 5,
    bonusTicketsCount: 1,
    bonusTicketNumbers: ['MINI-BONUS-9908'],
    unitPrice: 2000,
    totalAmount: 10000,
    purchasedAt: '2026-08-08T16:45:00Z',
    status: 'active',
    verificationHash: 'SHA256-MINI-2201-778899AA',
    secretVerificationPin: '1122',
  },
  {
    id: 'tick_starter_1001',
    ticketNumber: 'STARTER-2026-1101',
    tierId: 'starter',
    tierName: 'Starter Citizen Raffle',
    buyerName: 'Prince Albert Uzairue Jr.',
    buyerPhone: '+234 803 999 1122',
    buyerEmail: 'albert.jr@erueuzairue.org',
    buyerClanOrCity: 'Jattu-Uzairue',
    quantity: 10,
    bonusTicketsCount: 2,
    bonusTicketNumbers: ['STARTER-BONUS-001', 'STARTER-BONUS-002'],
    unitPrice: 500,
    totalAmount: 5000,
    purchasedAt: '2026-08-10T11:30:00Z',
    status: 'active',
    verificationHash: 'SHA256-STARTER-1101-33445566',
    secretVerificationPin: '8810',
  },
];

export const INITIAL_SETTLEMENT_RECORDS: WinnerSettlementRecord[] = [
  {
    id: 'settle-01',
    ticketNumber: 'MEGA-2026-8812',
    tierId: 'mega',
    tierName: 'Mega Royal Grand Raffle',
    winnerName: 'High Chief Raymond Braimoh',
    winnerPhone: '+234 803 112 4492',
    winnerEmail: 'raymond.b@uzairue.org',
    winnerClanOrCity: 'Jattu-Uzairue',
    prizeTitle: '10kVA Solar Hybrid Generator System',
    prizeType: 'item',
    verificationPin: '7721',
    verificationHash: 'SHA256-MEGA-8812-990A1B2C',
    status: 'approved_for_payout',
    payoutBankDetails: {
      bankName: 'First Bank of Nigeria',
      accountNumber: '3049921008',
      accountName: 'Raymond Braimoh',
    },
    payoutReceiptVoucherNo: 'UZA-ROYAL-PAY-2026-0091',
    approvedByOfficial: 'Ikpemhi Oshioke (Global Admin)',
    settledAt: '2026-08-12T14:30:00Z',
    claimDate: '2026-08-11T09:00:00Z',
  },
];
